import BusinessCodeBanner from './BusinessCodeBanner';

export default BusinessCodeBanner;
